var Upload = function (settings) {
    var self = this;
    var currentPage = 'computer';
    var friendsTemplate = $('#friends-list-upload-template').html();
    var albumsTemplate = $('#albums-list-upload-template').html();
    var photosTemplate = $('#photos-list-upload-template').html();
    var GalleryButtonsTemplate = $('#gallery-upload-btns-template').html();
    var currentList = '';
    var xhr = null;

    function init() {
        initHeightLists();
        self.gallery.section.get(self.productGroupId);
    }

    function upload(photos) {
        var total = Object.keys(photos).length;
        var uploaded = 0;
        var total_percent = 0;

        if (settings.hasOwnProperty('startUpload')) {
            settings.startUpload();
        }

        self.showContainer('upload-loader-page');
        $('#upload-loader-page').find('.progress-bar').addClass('active');

        uploadProgress(0);
        var key = Object.keys(photos)[uploaded];
        uploadItem();

        function uploadItem() {
            // Копия: settings.multipart_params отдан в liteUploader по ссылке,
            // picture в нём сломает следующую загрузку с компьютера (FormData отправит "[object Object]").
            var params = $.extend({}, settings.multipart_params, { picture: { key: photos[key] } });
            xhr = $.post(settings.upload_url, params, null, 'json')
                .done(function (response) {
                    if (!response.hasOwnProperty('errors')) {
                        settings.fileUploaded(response);

                        uploaded++;
                        total_percent = parseInt(uploaded / total * 100);
                        uploadProgress(total_percent);

                        if (uploaded === total) {
                            uploadComplete();
                            return false;
                        }

                        key = Object.keys(photos)[uploaded];
                        uploadItem();
                    } else {
                        self.dialog.show('message', { message: response.errors });
                        uploadComplete();
                    }
                })
                .fail(function (jqXHR, textStatus) {
                    // abort приходит от cancel() — там уже показан свой uploadComplete(), доп. диалог не нужен.
                    if (textStatus === 'abort') {
                        return;
                    }

                    var message = (jqXHR.responseJSON && jqXHR.responseJSON.message) || Yii.t('Loading error');
                    self.dialog.show('message', { message: message });
                    uploadComplete();
                });
        }
    }

    function cancel() {
        if (currentPage === 'computer') {
            $('.fileUpload').data("liteUploader").cancelUpload();
        } else {
            xhr.abort();
            uploadComplete();
        }
    }

    function uploadProgress(total_percent) {
        $('#upload-files-progress').css('width', total_percent + '%').attr('aria-valuenow', total_percent).text(total_percent + '%');
    }

    function uploadComplete() {
        $('#upload-loader-page').find('.progress-bar').removeClass('active');
        settings.uploadComplete();
    }

    function showPage(name, id) {
        self[name].show(function () {
            $('.page').addClass('invisible');
            $('#' + name + '-page').removeClass('invisible');
            currentPage = name;
            showCurrentList();
        }, id);
    }

    function showPreviousList() {
        var orderList = self[currentPage].orderList;

        var i, item;
        for (i in orderList) {
            item = orderList[i];
            if (item === currentList) {
                if (i !== '0') {
                    currentList = orderList[i - 1];
                } else {
                    self.showContainer('upload-page');
                    return;
                }
            }
        }

        showCurrentList();
    }

    function showCurrentList() {
        var orderList = self[currentPage].orderList;
        var i, item;

        for (i in orderList) {
            item = orderList[i];
            if (item !== currentList) {
                $('#' + currentPage + '-page .' + item + '-list').addClass('hidden-xs');
            } else {
                $('#' + currentPage + '-page .' + item + '-list').removeClass('hidden-xs');
            }
        }
    }

    function setFriend(el, uid) {
        $('.set-friend').removeClass('active');
        $(el).addClass('active');
        currentList = 'albums';
        showCurrentList();
        self[currentPage].selectFriend(uid);
    }

    function setAlbum(el, uid, aid) {
        $('.set-album').removeClass('active');
        $(el).addClass('active');
        currentList = 'photos';
        showCurrentList();
        self[currentPage].selectAlbum(uid, aid);
    }

    function setPhoto(el, pid, img) {
        if ($(el).hasClass('active')) {
            $(el).removeClass('active');
            delete self[currentPage].selectedPictures[pid];
        } else {
            $(el).addClass('active');
            self[currentPage].selectedPictures[pid] = img;
        }

        var count = Object.keys(self[currentPage].selectedPictures).length;
        if (count > 0) {
            $('#' + currentPage + '-page .upload-selected').removeClass('hide');
        } else {
            $('#' + currentPage + '-page .upload-selected').addClass('hide');
        }
    }

    function uploadSelected() {
        upload(self[currentPage].selectedPictures);
    }

    function initUploadImages() {
        var $elements = $('#' + currentPage + '-page .set-photo, #' + currentPage + '-page .set-album');
        $.each($elements, function () {
            $(this).height($(this).width());
        });
    }

    function initHeightLists() {
        var $elements = $(".friends-list, .albums-list, .photos-list");
        if ($(window).width() >= 768) {
            $elements.height($(window).height() - 100);
        } else {
            $elements.css('height', 'auto');
        }
    }

    self.uploadFotoswapImages = function () {
        var urls = window.fotoswapImages || [];
        window.fotoswapImages = [];

        if (!urls.length) {
            return;
        }

        currentPage = 'fotoswap';

        upload(urls);
    };

    self.gallery = {};
    self.gallery.catalogId = 0;
    self.gallery.selectedPictures = {};
    self.gallery.section = {};
    self.gallery.catalog = {};
    self.gallery.subcatalog = {};
    self.gallery.image = {};
    self.gallery.orderList = ['friends', 'albums', 'photos'];

    self.gallery.section.get = function (productGroupId) {
        self.loader.show(Yii.t('Getting Gallery Sections'));

        self.request.get(window.requestUrls.getGallerySection + '/' + productGroupId, function (response) {
            self.loader.hide();

            if (response.hasOwnProperty('error')) {
                self.dialog.show('message', { message: response.error });
                return false;
            }

            self.gallery.section.render(response.sections);
        }, 'json');
    };

    self.gallery.section.render = function (sections) {
        var data = {
            sections: []
        };

        for (var i in sections) {
            data.sections.push(sections[i]);
        }

        var html = self.templater.render(GalleryButtonsTemplate, data);
        $('#gallery-upload-btns').html(html);
    };

    self.gallery.catalog.get = function (id) {
        self.loader.show(Yii.t('Getting catalogs'));

        self.request.get(window.requestUrls.getGalleryCatalog + '/' + id, function (response) {
            self.loader.hide();

            if (response.hasOwnProperty('error')) {
                self.dialog.show('message', { message: response.error });
                return false;
            }

            self.gallery.catalog.render(response.catalogs);
        }, 'json');
    };

    self.gallery.catalog.render = function (items) {
        var data = { items: [] };

        var i, item;
        for (i in items) {
            item = items[i];
            data.items.push({
                user: item.id,
                name: item.name
            });
        }

        var html = self.templater.render(friendsTemplate, data);
        $('#gallery-page .friends-list').html(html);
        $('#gallery-page .albums-list').empty();
        $('#gallery-page .photos-list').empty();
    };

    self.gallery.subcatalog.get = function (id) {
        self.loader.show(Yii.t('Getting themes'));

        self.request.get(window.requestUrls.getGalleryCatalog + '/0/' + id, function (response) {
            self.loader.hide();

            if (response.hasOwnProperty('error')) {
                self.dialog.show('message', { message: response.error });
                return false;
            }

            self.gallery.subcatalog.render(response.catalogs);
        }, 'json');
    };

    self.gallery.subcatalog.render = function (items) {
        var data = { items: [] };

        data.items.push({
            id: 0,
            user: self.gallery.catalogId,
            name: Yii.t('All'),
            is_active: true
        });

        var i, item;
        for (i in items) {
            item = items[i];
            data.items.push({
                id: item.id,
                user: item.parent_id,
                name: item.name
            });
        }

        var html = self.templater.render(albumsTemplate, data);
        $('#gallery-page .albums-list').html(html);
    };

    self.gallery.image.get = function (catalogId, subCatalogId) {
        subCatalogId = subCatalogId || 0;

        self.loader.show(Yii.t('Getting photos'));

        self.request.get('/api/gallery/image/get/' + catalogId + '/' + subCatalogId, function (response) {
            self.loader.hide();

            if (response.hasOwnProperty('error')) {
                self.dialog.show('message', { message: response.error });
                return false;
            }

            self.gallery.image.render(response.images);
        }, 'json');
    };

    self.gallery.image.render = function (items) {
        self.gallery.selectedPictures = {};

        var data = { items: [] };

        var i, item;
        for (i in items) {
            item = items[i];

            data.items.push({
                id: item.id,
                url: '/img/uploaded/gallery/' + item.company_id + '/preview/' + item.id + '.jpg',
                data_url: 'http://' + location.hostname + '/img/uploaded/gallery/' + item.company_id + '/original/' + item.id + '.jpg'
                //name: item.name.strengh !== 0 ? item.name : false
            });
        }

        var html = self.templater.render(photosTemplate, data);
        $('#gallery-page .photos-list').html(html);;
        initUploadImages();
    };

    self.gallery.show = function (cb, id) {
        currentList = 'friends';
        self.gallery.catalog.get(id);
        cb();
    };

    self.gallery.selectFriend = function (id) {
        self.gallery.catalogId = id;
        self.gallery.subcatalog.get(id);
        self.gallery.image.get(id);
    };

    self.gallery.selectAlbum = function (catalogId, subCatalogId) {
        self.gallery.image.get(catalogId, subCatalogId);
    };


    self.computer = {};
    self.computer.isInit = false;

    self.computer.init = function () {
        var files = [];
        var total = 0;
        var uploaded = 0;
        var total_percent = 0;
        var isShowDialog = false;
        var errorFiles = [];

        function getAllowedFileTypes() {
            return settings.mime_types === undefined ? 'image/jpeg' : settings.mime_types;
        }

        function startFiles($input, list) {
            isShowDialog = false;
            files = Array.from(list);
            total = files.length;
            uploaded = 0;
            total_percent = 0;
            // Отмена загрузки должна уйти в liteUploader, даже если до этого открывали VK или галерею.
            currentPage = 'computer';

            self.showContainer('upload-loader-page');
            $('#upload-loader-page').find('.progress-bar').addClass('active');
            uploadProgress(total_percent);
            $input.data("liteUploader").startUpload([files[uploaded]]);
            $('#upload-file-progress').parent().removeClass('hide');
        }

        // Повторяет проверку типа из liteUploader (_isAllowedFileType), включая маски вида image/*.
        function isAllowedFileType(type) {
            var rules = getAllowedFileTypes();

            if (!rules) {
                return true;
            }

            var allowedTypes = rules.split(',');

            if ($.inArray(type, allowedTypes) !== -1) {
                return true;
            }

            return allowedTypes.reduce(function (result, allowedType) {
                if (result) {
                    return result;
                }

                var matches = allowedType.match(/([a-z]+)\/\*$/) || [];

                return matches[1] === type.split('/')[0];
            }, false);
        }

        // Папки в dataTransfer.files приходят одной записью нулевого размера, их не грузим.
        function filterDroppedFiles(list) {
            return Array.from(list).filter(function (file) {
                return file.size > 0 && isAllowedFileType(file.type);
            });
        }

        function initDropZone($input) {
            var $zone = $('.js-upload-drop');

            if ($zone.length === 0) {
                return;
            }

            $zone.on('dragenter dragover', function (e) {
                // Без preventDefault браузер не отдаст событие drop.
                e.preventDefault();
                e.stopPropagation();
                $zone.addClass('hover');
            });

            $zone.on('dragleave dragend', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $zone.removeClass('hover');
            });

            $zone.on('drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $zone.removeClass('hover');

                var dropped = filterDroppedFiles(e.originalEvent.dataTransfer.files);

                if (dropped.length === 0) {
                    self.dialog.show('message', { message: $zone.data('empty-message') });
                    return;
                }

                startFiles($input, dropped);
            });
        }

        if (!self.computer.isInit) {
            var $fileUpload = $('.fileUpload');

            $fileUpload.liteUploader({
                ref: settings.ref ?? null,
                script: settings.upload_url,
                rules: {
                    allowedFileTypes: getAllowedFileTypes(),
                    maxSize: settings.maxSize === undefined ? 35000000 : settings.maxSize, // 35mb
                },
                params: settings.multipart_params === undefined ? {} : settings.multipart_params,
                singleFileUploads: true
            })
                .on('lu:fail', function (e, response) {
                    var message = Yii.t('Please try again.');

                    if (response.status === 422) {
                        var lines = [];

                        response.responseJSON.forEach(function (error) {
                            lines.push(error.message);
                        })

                        message = files[uploaded].name + ':<br>' + lines.join('<br>')
                    }

                    if (!isShowDialog) {
                        self.dialog.show('message', { message: message });
                        isShowDialog = true;
                    }

                    uploaded++;
                    total_percent = parseInt(uploaded / total * 100);
                    uploadProgress(total_percent);
                    if (uploaded === total) {
                        uploadComplete();
                        $('#upload-file-progress').parent().addClass('hide');
                        $(this).val('');
                    } else {
                        $(this).data("liteUploader").startUpload([files[uploaded]]);
                    }
                })
                .on('lu:errors', function (e, errors) {
                    var message, error = errors[0].errors[0];
                    switch (error.type) {
                        case 'size':
                            var size = parseInt(error.rule / 1000 / 1000);
                            message = Yii.t('The size of the uploaded file exceeds the allowable limit of {size} mb.', { size });
                            break;
                        case 'type':
                            var types = error.rule.split(',');
                            for (var i in types) {
                                types[i] = types[i].split('/')[1];
                            }

                            types = types.join(', ');
                            message = Yii.t('It is possible to upload files only with the extension {types}', { types });
                            break;
                    }

                    if (!isShowDialog) {
                        self.dialog.show('message', { message: message });
                        isShowDialog = true;
                    }

                    uploaded++;
                    total_percent = parseInt(uploaded / total * 100);
                    uploadProgress(total_percent);
                    if (uploaded === total) {
                        uploadComplete();
                        $('#upload-file-progress').parent().addClass('hide');
                        $(this).val('');
                    } else {
                        $(this).data("liteUploader").startUpload([files[uploaded]]);
                    }
                })
                .on('lu:success', function (e, response) {
                    try {
                        // response = JSON.parse(response);
                        if (response.hasOwnProperty('errors')) {
                            errorFiles.push(files[uploaded].name + ' - ' + response.errors)
                        }

                        settings.fileUploaded(response);

                        uploaded++;
                        total_percent = parseInt(uploaded / total * 100);
                        uploadProgress(total_percent);

                        if (uploaded === total) {
                            uploadComplete();
                            $(this).val('');
                            $('#upload-file-progress').parent().addClass('hide');

                            if (errorFiles.length > 0) {
                                self.dialog.show('message', { message: errorFiles.join('<br>') + '<br><br>' + Yii.t('Please try again.') });
                                errorFiles = [];
                            }
                        } else {
                            $(this).data("liteUploader").startUpload([files[uploaded]]);
                        }
                    } catch (e) {
                        console.log(e);
                        self.dialog.show('message', { message: Yii.t('Loading error') });
                        uploadComplete();
                        $(this).val('');
                    }
                })
                .on('lu:cancelled', function (e, response) {
                    uploadComplete();
                    $(this).val('');
                    $('#upload-file-progress').parent().addClass('hide');
                })
                .on('lu:progress', function (e, percentage) {
                    $('#upload-file-progress').css('width', percentage + '%').attr('aria-valuenow', percentage).text(percentage + '%');
                })
                .on('lu:start', function (e, files) {
                    if (settings.hasOwnProperty('startUpload')) {
                        settings.startUpload();
                    }
                })
                .change(function () {
                    var list = $(this).data("liteUploader")._getFiles();

                    if (list.length === 0) {
                        uploadComplete();
                        return;
                    }

                    startFiles($(this), list);
                });

            initDropZone($fileUpload);

            self.computer.isInit = true;
        }
    };

    self.albums = {};
    self.albums.selectedPictures = {};
    self.albums.orderList = ['albums', 'photos'];

    self.albums.show = function (cb) {
        currentList = 'albums';
        self.albums.selectedPictures = {};
        var uid = self.user.data.id;
        if (uid) {
            self.loader.show(Yii.t('Getting a list of albums'));
            $.post('/albums/ajax_get_albums', { uid: uid }, function (response) {
                self.loader.hide();
                if (!response.hasOwnProperty('errors')) {
                    var data = { items: [] }, item, i, html;
                    for (i in response.albums) {
                        item = response.albums[i];
                        data.items.push(item);
                    }

                    html = self.templater.render(albumsTemplate, data);
                    $('#albums-page .albums-list').html(html);

                    cb();
                } else {
                    self.dialog.show('message', { message: response.errors });
                }
            }, 'json');
        } else {
            self.dialog.show('login', { domain: encodeURIComponent(window.location.origin) }, function () {
                if (self.user.data.id) {
                    showPage('albums');
                }
            });
        }
    };

    self.albums.selectAlbum = function (uid, aid) {
        self.loader.show(Yii.t('Get album photos'));
        $.post('/albums/ajax_get_photos', { aid: aid }, function (response) {
            self.loader.hide();
            if (!response.hasOwnProperty('errors')) {
                var data = {
                    items: response.photos
                };
                self.albums.selectedPictures = {};
                var i, item;
                for (i in response.photos) {
                    item = response.photos[i];
                    item.url = item.thumbnail;
                    item.data_url = '/upload/albums/' + self.user.data.id + '/' + item.album_id + '/' + item.img;
                }

                var html = self.templater.render(photosTemplate, data);
                $('#albums-page .photos-list').html(html);
                initUploadImages();
            } else {
                self.dialog.show('message', { message: response.errors });
            }
        }, 'json');
    };

    self.vk = {};
    self.vk.userId = false;
    self.vk.workUserId = false;
    self.vk.isInit = false;
    self.vk.selectedPictures = {};
    self.vk.orderList = ['friends', 'albums', 'photos'];

    self.vk.show = function (cb) {
        currentList = 'friends';
        if (!self.vk.userId) {
            var windowVK = window.open('', 'vk', 'width=700,height=400');
            $.post('/api/vk/get_authorize_url', function (response) {
                windowVK.location.href = response.authorize_url;
            }, 'json');
        } else {
            self.vk.getFriends(self.vk.userId);
        }

        cb();
    };

    self.vk.setData = function (data) {
        self.vk.userId = data.user_id;
        self.vk.workUserId = data.user_id;
        self.vk.accessToken = data.access_token;
        self.vk.getFriends(self.vk.userId);
    };

    self.vk.getFriends = function (uid) {
        self.loader.show(Yii.t('Getting a list of friends'));
        $.post('/api/vk/get_friends', { uid: uid, access_token: self.vk.accessToken }, self.vk.renderFriends, 'json');
    };

    self.vk.selectFriend = function (uid) {
        self.vk.workUserId = uid;
        self.loader.show(Yii.t('Getting a list of albums'));
        $.post('/api/vk/get_albums', { uid: uid, access_token: self.vk.accessToken }, self.vk.renderAlbums, 'json');
    };

    self.vk.selectAlbum = function (uid, aid) {
        self.loader.show(Yii.t('Get album photos'));
        if (aid != 'all') {
            $.post('/api/vk/get_photos', { owner_id: uid, album_id: aid, access_token: self.vk.accessToken }, self.vk.renderPhotos, 'json');
        } else {
            $.post('/api/vk/get_photos_all', { owner_id: uid, access_token: self.vk.accessToken }, self.vk.renderPhotos, 'json');
        }
    };

    self.vk.renderFriends = function (friends) {
        self.loader.hide();
        var data = { items: [] };
        data.items.push({
            user: self.vk.userId,
            name: Yii.t('My albums')
        });

        var i, item;
        for (i in friends.response.items) {
            item = friends.response.items[i];
            data.items.push({
                user: item.id,
                name: item.first_name + ' ' + item.last_name
            });
        }

        var html = self.templater.render(friendsTemplate, data);
        $('#vk-page .friends-list').html(html);
        $('#vk-page .albums-list').empty();
        $('#vk-page .photos-list').empty();
    };

    self.vk.renderAlbums = function (albums) {
        self.loader.hide();
        var data = { items: [] };
        data.items.push({
            id: 'all',
            user: self.vk.workUserId,
            name: Yii.t('Recent Photos')
        });

        var i, item;
        for (i in albums.response.items) {
            item = albums.response.items[i];
            data.items.push({
                id: item.id,
                user: item.owner_id,
                name: item.title
            });
        }

        var html = self.templater.render(albumsTemplate, data);
        $('#vk-page .albums-list').html(html);
    };

    self.vk.renderPhotos = function (photos) {
        self.loader.hide();
        self.vk.selectedPictures = {};

        var data = { items: [] };

        var i, item, type;
        var j, size;
        for (i in photos.response.items) {
            item = photos.response.items[i];

            if (typeof item !== 'object') {
                continue;
            }

            var url = null;
            var dataUrl = null;

            // allowed sizes by priority
            const allowedSizes = ['w', 'z', 'y', 'r', 'q'];
            for (k in allowedSizes) {
                for (j in item.sizes) {
                    size = item.sizes[j];
                    if (size.type === allowedSizes[k]) {
                        dataUrl = size.url;
                        break;
                    }
                }
            }

            const minSize = 'm';
            for (j in item.sizes) {
                size = item.sizes[j];

                if (size.type === minSize) {
                    url = size.url;
                    break;
                }
            }

            if (!url || !dataUrl) {
                continue;
            }

            data.items.push({
                id: item.id,
                url: url,
                data_url: dataUrl
            });
        }

        var html = self.templater.render(photosTemplate, data);
        $('#vk-page .photos-list').html(html);
        initUploadImages();
    };


    self.instagram = {};
    self.instagram.isInit = false;
    self.instagram.accessToken = false;
    self.instagram.selectedPictures = {};
    self.instagram.orderList = ['photos'];
    self.instagram.nextUrl = null;
    self.instagram.doRequest = false;
    self.instagram.currentAlbum = null;

    self.instagram.scrollHandler = function (wrap) {
        if (
            wrap.scrollHeight - wrap.scrollTop <= wrap.offsetHeight
            && self.instagram.nextUrl !== null
            && !self.instagram.doRequest
        ) {
            self.instagram.getPhotos('me/media');
        }
    };

    self.instagram.show = function (cb) {
        currentList = 'photos';
        if (!self.instagram.accessToken) {
            self.instagram.login();
        } else {
            self.instagram.selectedPictures = {};
            $('#instagram-page .set-photo').removeClass('active');
        }

        cb();
    };

    self.instagram.login = function () {
        window.open(
            'https://fotis.su/api/instagram/login?referer=' + window.location.href,
            'instagram',
            'width=650,height=350'
        );
    };

    self.instagram.setData = function (data) {
        console.log(data);
        self.instagram.accessToken = data.access_token;
        $('#instagram-page .photos-list').empty();
        self.instagram.getPhotos('me/media');
    };

    self.instagram.back = function () {
        if (self.instagram.currentAlbum) {
            $('#instagram-page .photos-list').empty();
            self.instagram.currentAlbum = null;
            self.instagram.getPhotos('me/media');
        } else {
            self.showContainer('upload-page');
        }
    };

    self.instagram.selectAlbum = function (uid, aid) {
        self.loader.show(Yii.t('Getting a list of albums'));
        self.instagram.currentAlbum = aid;
        $('#instagram-page .photos-list').empty();
        self.instagram.getPhotos(aid + '/children');
    };

    self.instagram.getPhotos = function (url) {
        self.loader.show(Yii.t('Getting photos'));
        self.instagram.doRequest = true;
        $.ajax({
            url: self.instagram.nextUrl || 'https://graph.instagram.com/' + url,
            data: { access_token: self.instagram.accessToken, fields: 'id,media_type,media_url' },
            type: 'GET',
            crossDomain: true,
            dataType: 'jsonp',
            success: self.instagram.renderPhotos
        });
    };

    self.instagram.renderPhotos = function (response) {
        self.loader.hide();
        console.log(response);

        var data = { items: [] };
        var i, item;
        for (i in response.data) {
            item = response.data[i];

            if (item.media_type !== 'IMAGE' && item.media_type !== 'CAROUSEL_ALBUM') {
                continue;
            }

            data.items.push({
                id: item.id,
                is_album: item.media_type === 'CAROUSEL_ALBUM',
                url: item.media_url,
                data_url: item.media_url
            });
        }

        var html = self.templater.render(photosTemplate, data);
        $('#instagram-page .photos-list').append(html);
        initUploadImages();

        self.instagram.nextUrl = null;
        if (response.hasOwnProperty('paging') && response.paging.hasOwnProperty('next')) {
            self.instagram.nextUrl = response.paging.next;
        }

        self.instagram.doRequest = false;
    };

    self.fotoswap = {};
    self.fotoswap.selectedPictures = {};
    self.fotoswap.orderList = ['photos'];
    self.fotoswap.timeoutID = null;

    self.fotoswap.resetSelection = function () {
        self.fotoswap.selectedPictures = {};
        $('#fotoswap-page .upload-selected').addClass('hide');
        $('#fotoswap-page .set-photo').removeClass('active');
    };

    // Как images = [] в photoprint/Fotoswap.vue: пустой список и «Изображения не найдены».
    self.fotoswap.resetPhotoList = function () {
        self.fotoswap.resetSelection();
        $('#fotoswap-page .photos-list').empty();
        $('#fotoswap-page .js-fotoswap-empty').removeClass('hide');
    };

    self.fotoswap.show = function (cb) {
        currentList = 'photos';
        self.fotoswap.resetSelection();
        cb();
    };

    self.fotoswap.onUrlInput = function (url) {
        if (self.fotoswap.timeoutID !== null) {
            clearTimeout(self.fotoswap.timeoutID);
        }

        url = $.trim(url);

        if (!url) {
            self.fotoswap.resetPhotoList();
            return;
        }

        self.fotoswap.timeoutID = setTimeout(function () {
            self.fotoswap.fetchImages(url);
        }, 1000);
    };

    self.fotoswap.fetchImages = function (url) {
        self.loader.show(Yii.t('Getting photos'));
        self.fotoswap.resetPhotoList();

        $.ajax({
            url: '/fotoswap/api/image',
            data: { url: url },
            dataType: 'json',
        })
            .done(function (response) {
                var data = { items: [] };
                var payload = response && response.data ? response.data : response;

                Object.values(payload || {}).forEach(function (item) {
                    if (!item || !item.url) {
                        return;
                    }

                    data.items.push({
                        id: item.id,
                        name: item.name || '',
                        url: item.preview_url,
                        data_url: item.url
                    });
                });

                if (data.items.length === 0) {
                    return;
                }

                $('#fotoswap-page .js-fotoswap-empty').addClass('hide');
                var html = self.templater.render(photosTemplate, data);
                $('#fotoswap-page .photos-list').html(html);
                initUploadImages();
            })
            .fail(function (xhr) {
                var message = (xhr.responseJSON && xhr.responseJSON.message)
                    ? xhr.responseJSON.message
                    : Yii.t('Loading error');

                self.dialog.show('message', { message: message });
            })
            .always(function () {
                self.loader.hide();
                self.fotoswap.timeoutID = null;
            });
    };

    init();

    window.addEventListener("message", function (event) {
        try {
            var data = JSON.parse(event.data);
            if (data.hasOwnProperty('vk')) {
                self.vk.setData(data.vk);
            }

            if (data.hasOwnProperty('instagram')) {
                self.instagram.setData(data.instagram);
            }
        } catch (err) {
            console.log(err);
        }
    }, false);

    $(document).on('click', '.upload-btn', function () {
        showPage($(this).attr('data-page'), $(this).attr('data-id'));
    });

    $(document).on('click', '.upload-back', function () {
        self.showContainer('upload-page');
    });

    $(document).on('click', '.upload-list-back', function () {
        showPreviousList();
    });

    $(document).on('click', '.set-friend', function () {
        setFriend(this, $(this).attr('data-uid'));
    });

    $(document).on('click', '.set-album', function () {
        setAlbum(this, $(this).attr('data-uid'), $(this).attr('data-aid'));
    });

    $(document).on('click', '.set-photo', function () {
        setPhoto(this, $(this).attr('data-pid'), $(this).attr('data-img'));
    });

    $(document).on('input', '.js-fotoswap-url', function () {
        self.fotoswap.onUrlInput($(this).val());
    });

    $(document).on('submit', '#ya-set-user', function (e) {
        e.preventDefault();
        self.ya.renderAlbums();
    });

    $(document).on('click', '.upload-selected', function () {
        uploadSelected();
    });

    $(document).on('click', '.upload-hide', function () {
        self.showContainer('main-page');
    });

    $(document).on('click', '.upload-cancel', function () {
        cancel();
    });

    $('.upload-instagram-back').on('click', function (e) {
        self.instagram.back();
    });

    $('#instagram-page .photos-list').on('scroll', function () {
        self.instagram.scrollHandler(this);
    });

    $('#instagram-page .photos-list').on('touchmove', function (e) {
        self.instagram.scrollHandler($('body')[0]);
    });

    $(document).on('mousewheel', '#instagram-page .photos-list', function () {
        if (self.instagram.nextUrl !== null) {
            self.instagram.getPhotos('me/media');
        }
    });

    $(window).resize(function () {
        initUploadImages();
        initHeightLists();
    });
};
